export default function ANALYTICS() {
  // Google Analytics
  if (!document.getElementById('gtag-js')) {
    const gtagScript = document.createElement('script');
    gtagScript.id = 'gtag-js';
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-11CHYW3K6Z';
    document.head.appendChild(gtagScript);
  }
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', 'G-11CHYW3K6Z');

  // Meta Pixel
  if (!window.fbq) {
    window.fbq = function() {
      window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
    };
    window.fbq.queue = [];
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    const fbqScript = document.createElement('script');
    fbqScript.async = true;
    fbqScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(fbqScript);
  }
  window.fbq('init', '727105113056303');
  window.fbq('track', 'PageView');

  // Snap Pixel
  if (!window.snaptr) {
    window.snaptr = function() {
      window.snaptr.handleRequest ? window.snaptr.handleRequest.apply(window.snaptr, arguments) : window.snaptr.queue.push(arguments);
    };
    window.snaptr.queue = [];
    const snaptrScript = document.createElement('script');
    snaptrScript.async = true;
    snaptrScript.src = 'https://sc-static.net/scevent.min.js';
    document.head.appendChild(snaptrScript);
  }
  window.snaptr('init', '0e29f2de-37c1-4e4f-8274-c4d2f40d4bd7');
  window.snaptr('track', 'PAGE_VIEW');
}
